module.exports = __webpack_public_path__ + "img/block-1920.ecbe999e.jpg";